import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  UPDATE_HIPAA_CONSENT,
  saveHipaaAuthConsentToCache,
} from '@pass-frontend/common/data-access';
import { IMutation } from '@pass-frontend/data-access/common/edge';

export const useUpdateHipaaConsent = () => {
  const [updateHipaaConsent] = useMutation<
    Pick<IMutation, 'updateHipaaConsent'>
  >(UPDATE_HIPAA_CONSENT, {
    update: saveHipaaAuthConsentToCache,
  });

  const handleUpdateHipaaConsent = useCallback(() => {
    return updateHipaaConsent();
  }, [updateHipaaConsent]);

  return {
    handleUpdateHipaaConsent,
  };
};
